import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/index-of";
import { LOCALHOST_MODE, STANDALONE_MODE, PRODUCER_MODE, CONSUMER_MODE } from '../constants';
function mode(key, mode) {
  var _context;

  // Leaving the comparison as is, in case we change the mode name but not the setting.
  if (key === 'localhost') return LOCALHOST_MODE;
  if (_indexOfInstanceProperty(_context = [STANDALONE_MODE, PRODUCER_MODE, CONSUMER_MODE]).call(_context, mode) === -1) throw Error('Invalid mode provided');
  return mode;
}
export default mode;